module.exports = __webpack_public_path__ + "static/media/group.f75b7745.svg";